import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Select, DatePicker, Cascader } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { generateOptions } from '../../../shared/selectFn';
import { DisplayType } from '../../constants/common';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { Option } = Select;
const { MonthPicker } = DatePicker;
const displayTypeOption = generateOptions(DisplayType);

const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]


class Filter extends Component {
    static contextTypes = {
        systemDate: PropTypes.object,
        isSeniorUserBo: PropTypes.bool,
        FINANCE_INDICATOR_ANALYSIS: PropTypes.bool,
        isDesignatedTal: PropTypes.bool,
        isLineCharge: PropTypes.bool,
    }

    // 判断是否仅满足 isDesignatedTal 条件（其他权限条件均不满足）
    isOnlyDesignatedTal = () => {
        const { isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = this.context;
        const curRole = sessionStorage.curRole;
        return isDesignatedTal && curRole !== 'FIN' && !isSeniorUserBo && !FINANCE_INDICATOR_ANALYSIS && !isLineCharge;
    }

    componentDidMount() {
        this.autoFillLeader();
    }

    componentDidUpdate(prevProps) {
        // finance 场景：searchParams 变化时，先确保搜索条件完备（领域leader填充），再触发数据查询
        if (this.props.source === 'finance' && this.props.searchParams !== prevProps.searchParams) {
            if (this.isOnlyDesignatedTal() && !this.props.searchParams.talUserId) {
                this.autoFillLeader();
            } else {
                this.props.onSearch();
            }
        }
    }

    // 自动填充当前登录人为领域leader
    autoFillLeader = () => {
        if (this.props.source === 'finance' && this.isOnlyDesignatedTal()) {
            const { searchParams, onChange, onSearch } = this.props;
            const { userId } = sessionStorage;
            Fetch.post(API_URL.user.queryLeaderList, { userId, status: 'WORKING' }).then(res => {
                const { datas = [] } = res;
                if (datas.length > 0) {
                    const user = datas[0];
                    const newSearchParams = {
                        ...searchParams,
                        talUserId: user.userId,
                        talUserName: user.employeeCode ? `${user.userCompellation}[${user.employeeCode}]` : user.userCompellation,
                    };
                    // 先更新 searchParams（onChange），再触发查询（onSearch）
                    // 但 setState 是异步的，直接调用 onSearch 会读到旧 state
                    // 解决方案：将完整 searchParams 传给 onSearch，避免时序竞争
                    onChange(newSearchParams);
                    onSearch(newSearchParams);
                }
            });
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        // 创建全新副本，绝不改动父组件传入的对象
        const newParams = { ...searchParams };
        switch (key) {
            case 'talUser':
            case 'leaderUser':
            {
                const { value: id, text: name } = value;
                newParams[`${key}Id`] = id;
                newParams[`${key}Name`] = name;
                break;
            }
            default:
                newParams[key] = value;
                break;
        }
        onChange(newParams);
    }

    disabledDate = (current) => {
        const { systemDate: { date, trueYear } = {} } = this.context;
        const { params: { moduleType } } = this.props;
        const value = moment(
            moduleType !== 'MonthOrderInHand' ? format('month', date) : `${trueYear + 3}-12`
        ).add(1, 'M').valueOf();
        return current && current.valueOf() >= value;
    }

    render() {
        const { systemDate: { trueYear } } = this.context;
        const { type, params, searchParams, source, onSearch, onExport } = this.props;
        const { moduleType, analysisDimension, lineOfBusiness } = params;
        const statisticsDateOption = [];
        let start = 2016,
            end = (trueYear || 2016);
        if (moduleType === 'MonthOrderInHand') {
            end += 3;
        }
        for (; start <= end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        const medicineTypeOptions = MedicineTypeList.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        return (
            <div className="chartFilter filter-wrap">
                {
                    (( source === "finance" &&
                    (
                        (analysisDimension === 'GLOBAL' && lineOfBusiness == -1) ||
                        analysisDimension === 'PROJECT_AREA' ||
                        analysisDimension === 'DISEASE' ||
                        analysisDimension === 'PROJECT'
                    )) || source == "person" || 
                    (source === "project" && (
                        analysisDimension === 'GLOBAL' || 
                        analysisDimension === 'PROJECT_AREA' || 
                        analysisDimension === 'DISEASE' ||  
                        analysisDimension === 'SICKNESS' || 
                        analysisDimension === 'PROJECT' 
                        )))&&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">统计形式</label>
                        <Select
                            placeholder="请选择"
                            value={format('toString', searchParams.displayType)}
                            style={{ width: 140, verticalAlign: 'middle' }}
                            onChange={value => this.handleChange(value, 'displayType')}
                        >
                            {displayTypeOption}
                        </Select>
                    </div>
                }
                {
                    (source !== "person" && moduleType !== 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH') &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">研究产品类型</label>
                        {/* <Select
                            placeholder="请选择"
                            style={{ width: 130 }}
                            allowClear={true}
                            value={searchParams.investigationMedicineType}
                            onChange={value => this.handleChange(value, 'investigationMedicineType')}
                        >
                            {medicineTypeOptions}
                        </Select> */}
                        <Cascader
                            allowClear={true}
                            style={{ width: 130 }}
                            placeholder="请选择"
                            options={MedicineTypeList}
                            value={searchParams.investigationMedicineType}
                            onChange={value => this.handleChange(value, 'investigationMedicineType')}
                        />
                    </div>
                }
                {
                    (source !== "person" ) &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">领域leader</label>
                        <SearchRetrieve
                            keyword='leaderName'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={source !== 'project' ? searchParams.talUserName : searchParams.leaderUserName}
                            params={{ limit: 20, status: 'ALL' }}
                            url={API_URL.user.queryLeaderList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, source !== 'project' ? 'talUser' : 'leaderUser')}
                            disabled={source === 'finance' && this.isOnlyDesignatedTal()}
                        />
                    </div>
                }
                <div className="filter-item">
                    <label className="filter-label">统计时间</label>
                    {
                        (type === 'map' && analysisDimension === 'CITY') ?
                            <MonthPicker
                                format={monthFormat}
                                allowClear={false}
                                disabledDate={this.disabledDate}
                                value={format('toMoment', searchParams.year)}
                                onChange={(date, dateString) => this.handleChange(dateString, 'year')}
                                style={{width: 100, verticalAlign: 'middle'}}
                            />
                        :
                            <Select
                                placeholder="请选择"
                                value={format('toString', searchParams.year)}
                                style={{ width: 100, verticalAlign: 'middle' }}
                                onChange={value => this.handleChange(value, 'year')}
                            >
                                {statisticsDateOption}
                            </Select>
                    }
                </div>
                <div className="filter-item">
                    <Button type="primary" onClick={() => onSearch()}>统计</Button>
                    { type !== 'map' && <Button className="btn-yellow" style={{ marginLeft: 10 }} onClick={onExport}>导出</Button> }
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/Filter.js